export enum MyCoachingCard {
    TOGGLE_CLICK = 'myCoachingCard.toggleClick',
    TREND_VIEW_CLICK = 'myCoachingCard.trendViewClick',
    SELECT_ITEM_CLICK = 'myCoachingCard.selectItemClick',
    RELOAD_CLICK = 'myCoachingCard.reloadClick',
}
